import { Entity, PrimaryGeneratedColumn, Column, ManyToMany, OneToMany } from "typeorm";
import { PaygEvCharger } from "./PaygEvCharger";
import { PaygTransaction } from "./PaygTransaction";
import { PaygVerificationToken } from "./PaygVerificationToken";
import { PaygPasswordResetToken } from "./PaygPasswordResetToken";

@Entity("payg_user")
export class PaygUser {
    @PrimaryGeneratedColumn()
    id?: number

    @Column({ nullable: false })
    email?: string

    @Column({ nullable: false })
    password?: string

    @Column({ nullable: false })
    isVerified?: boolean

    @ManyToMany(() => PaygEvCharger, paygEvCharger => paygEvCharger.users)
    paygDetails?: PaygEvCharger[]

    @OneToMany(() => PaygTransaction, paygTransaction => paygTransaction.user)
    transactions?: PaygTransaction[]

    @OneToMany(() => PaygVerificationToken, token => token.user)
    verificationTokens?: PaygVerificationToken[]

    @OneToMany(() => PaygPasswordResetToken, token => token.user)
    passwordResetTokens?: PaygPasswordResetToken[]
}
